module.exports = __webpack_public_path__ + "static/media/Cat Costume Girl.e42dd59e.jpg";